import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import config from "../../../config";

const SYNCHROEU_URL = config.SYNCHROEU_URL;

const SimulatedData = () => {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await axios.get(`${SYNCHROEU_URL}/scenarios/simulated-scenarios`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      setData(response.data?.data || []);
    } catch (err) {
      setError(t("scenarios.library.loadError"));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refetch: fetchData };
};

export default SimulatedData;
